/**
 * Größeneinstellungen für Widgets
 */
import React, { useState, useEffect } from 'react';

const SizeSettings = ({ config, onChange }) => {
  const [size, setSize] = useState({
    width: config.size?.width || 1,
    height: config.size?.height || 1
  });

  useEffect(() => {
    // Aktualisiere den State wenn sich die config ändert
    setSize({
      width: config.size?.width || 1,
      height: config.size?.height || 1
    });
  }, [config]);

  const handleWidthChange = (e) => {
    const newWidth = parseInt(e.target.value, 10);
    const updatedSize = {
      ...size,
      width: newWidth
    };
    
    setSize(updatedSize);
    
    // Benachrichtige das Eltern-Widget über die Änderungen
    if (onChange) {
      onChange({
        ...config,
        size: updatedSize
      });
    }
  };

  const handleHeightChange = (e) => {
    const newHeight = parseInt(e.target.value, 10);
    const updatedSize = {
      ...size,
      height: newHeight
    };
    
    setSize(updatedSize);
    
    // Benachrichtige das Eltern-Widget über die Änderungen
    if (onChange) {
      onChange({
        ...config,
        size: updatedSize
      });
    }
  };

  return (
    <div className="size-settings">
      <h3>Widget-Größe</h3>
      <div className="form-group">
        <label>
          Breite (1-6):
          <input
            type="range"
            min="1"
            max="6"
            value={size.width}
            onChange={handleWidthChange}
          />
          <span>{size.width}</span>
        </label>
      </div>
      <div className="form-group">
        <label>
          Höhe (1-9):
          <input
            type="range"
            min="1"
            max="9"
            value={size.height}
            onChange={handleHeightChange}
          />
          <span>{size.height}</span>
        </label>
      </div>
    </div>
  );
};

export default SizeSettings;
